package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class FinanceCategoryQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    name: String,
    type: String,
    icon: String,
    color: String,
    is_default: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(2_005_958_347, arrayOf("finance_category"), driver,
      "FinanceCategory.sq", "selectAll",
      "SELECT finance_category.id, finance_category.name, finance_category.type, finance_category.icon, finance_category.color, finance_category.is_default, finance_category.order_index, finance_category.created_at, finance_category.updated_at, finance_category.is_deleted, finance_category.deleted_at, finance_category.synced_at FROM finance_category WHERE is_deleted = 0 ORDER BY type, order_index, name") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10),
      cursor.getLong(11)
    )
  }

  public fun selectAll(): Query<Finance_category> = selectAll { id, name, type, icon, color,
      is_default, order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Finance_category(
      id,
      name,
      type,
      icon,
      color,
      is_default,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByType(type: String, mapper: (
    id: String,
    name: String,
    type: String,
    icon: String,
    color: String,
    is_default: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByTypeQuery(type) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10),
      cursor.getLong(11)
    )
  }

  public fun selectByType(type: String): Query<Finance_category> = selectByType(type) { id, name,
      type_, icon, color, is_default, order_index, created_at, updated_at, is_deleted, deleted_at,
      synced_at ->
    Finance_category(
      id,
      name,
      type_,
      icon,
      color,
      is_default,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectById(id: String, mapper: (
    id: String,
    name: String,
    type: String,
    icon: String,
    color: String,
    is_default: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10),
      cursor.getLong(11)
    )
  }

  public fun selectById(id: String): Query<Finance_category> = selectById(id) { id_, name, type,
      icon, color, is_default, order_index, created_at, updated_at, is_deleted, deleted_at,
      synced_at ->
    Finance_category(
      id_,
      name,
      type,
      icon,
      color,
      is_default,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    name: String,
    type: String,
    icon: String,
    color: String,
    is_default: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-711_653_764, arrayOf("finance_category"), driver, "FinanceCategory.sq",
      "selectDirty",
      "SELECT finance_category.id, finance_category.name, finance_category.type, finance_category.icon, finance_category.color, finance_category.is_default, finance_category.order_index, finance_category.created_at, finance_category.updated_at, finance_category.is_deleted, finance_category.deleted_at, finance_category.synced_at FROM finance_category WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10),
      cursor.getLong(11)
    )
  }

  public fun selectDirty(): Query<Finance_category> = selectDirty { id, name, type, icon, color,
      is_default, order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Finance_category(
      id,
      name,
      type,
      icon,
      color,
      is_default,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    name: String,
    type: String,
    icon: String,
    color: String,
    is_default: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10),
      cursor.getLong(11)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Finance_category> = selectByIdAnyState(id) { id_,
      name, type, icon, color, is_default, order_index, created_at, updated_at, is_deleted,
      deleted_at, synced_at ->
    Finance_category(
      id_,
      name,
      type,
      icon,
      color,
      is_default,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    name: String,
    type: String,
    icon: String,
    color: String,
    is_default: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(578_954_419, """
        |INSERT INTO finance_category(id, name, type, icon, color, is_default, order_index, created_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 9) {
          bindString(0, id)
          bindString(1, name)
          bindString(2, type)
          bindString(3, icon)
          bindString(4, color)
          bindLong(5, is_default)
          bindLong(6, order_index)
          bindLong(7, created_at)
          bindLong(8, updated_at)
        }
    notifyQueries(578_954_419) { emit ->
      emit("finance_category")
    }
  }

  public fun update(
    name: String,
    type: String,
    icon: String,
    color: String,
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(923_900_611, """
        |UPDATE finance_category
        |SET name = ?, type = ?, icon = ?, color = ?, order_index = ?, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 7) {
          bindString(0, name)
          bindString(1, type)
          bindString(2, icon)
          bindString(3, color)
          bindLong(4, order_index)
          bindLong(5, updated_at)
          bindString(6, id)
        }
    notifyQueries(923_900_611) { emit ->
      emit("finance_category")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_178_864_785,
        """UPDATE finance_category SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""",
        3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-1_178_864_785) { emit ->
      emit("finance_category")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(-91_901_996,
        """UPDATE finance_category SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(-91_901_996) { emit ->
      emit("finance_category")
    }
  }

  public fun hardDelete(id: String) {
    driver.execute(-1_358_926_992, """DELETE FROM finance_category WHERE id = ?""", 1) {
          bindString(0, id)
        }
    notifyQueries(-1_358_926_992) { emit ->
      emit("finance_category")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(24_028_833,
        """UPDATE finance_category SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(24_028_833) { emit ->
      emit("finance_category")
    }
  }

  private inner class SelectByTypeQuery<out T : Any>(
    public val type: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("finance_category", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("finance_category", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-629_801_273,
        """SELECT finance_category.id, finance_category.name, finance_category.type, finance_category.icon, finance_category.color, finance_category.is_default, finance_category.order_index, finance_category.created_at, finance_category.updated_at, finance_category.is_deleted, finance_category.deleted_at, finance_category.synced_at FROM finance_category WHERE type = ? AND is_deleted = 0 ORDER BY order_index, name""",
        mapper, 1) {
      bindString(0, type)
    }

    override fun toString(): String = "FinanceCategory.sq:selectByType"
  }

  private inner class SelectByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("finance_category", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("finance_category", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(2_055_207_912,
        """SELECT finance_category.id, finance_category.name, finance_category.type, finance_category.icon, finance_category.color, finance_category.is_default, finance_category.order_index, finance_category.created_at, finance_category.updated_at, finance_category.is_deleted, finance_category.deleted_at, finance_category.synced_at FROM finance_category WHERE id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "FinanceCategory.sq:selectById"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("finance_category", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("finance_category", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-256_530_931,
        """SELECT finance_category.id, finance_category.name, finance_category.type, finance_category.icon, finance_category.color, finance_category.is_default, finance_category.order_index, finance_category.created_at, finance_category.updated_at, finance_category.is_deleted, finance_category.deleted_at, finance_category.synced_at FROM finance_category WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "FinanceCategory.sq:selectByIdAnyState"
  }
}
